import React from 'react';

const typeColors = {
    NO_BB_WINNER: 'bg-red-100 text-red-800',
    WE_NEVER_WIN: 'bg-orange-100 text-orange-800',
    PARTIAL: 'bg-yellow-100 text-yellow-800',
};

export default function BuyboxStatus({ data }) {
    if (!data || data.length === 0) {
        return <p className="text-gray-500 py-4">No Buy Box status issues detected.</p>;
    }

    return (
        <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase">Product</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Inventory</th>
                        <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase">BB Status</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Our Price</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Lowest Competitor</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Days Checked</th>
                        <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase">Recent Sales</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {data.map((item, idx) => (
                        <tr key={idx} className="hover:bg-gray-50">
                            <td className="px-3 py-3 text-sm">
                                <div className="font-medium text-gray-900 truncate max-w-[200px]" title={item.productName}>
                                    {item.productName}
                                </div>
                                <div className="text-xs text-gray-400">{item.asin}</div>
                            </td>
                            <td className="px-3 py-3 text-sm text-right">{item.availableInventory}</td>
                            <td className="px-3 py-3 text-sm">
                                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${typeColors[item.bbStatus] || 'bg-gray-100 text-gray-600'}`}>
                                    {item.bbStatus?.replace(/_/g, ' ')}
                                </span>
                            </td>
                            <td className="px-3 py-3 text-sm text-right">
                                {item.ourPrice != null ? `$${Number(item.ourPrice).toFixed(2)}` : '-'}
                            </td>
                            <td className="px-3 py-3 text-sm text-right">
                                {item.lowestCompetitorPrice != null ? `$${Number(item.lowestCompetitorPrice).toFixed(2)}` : '-'}
                            </td>
                            <td className="px-3 py-3 text-sm text-right">{item.daysChecked}</td>
                            <td className="px-3 py-3 text-sm text-right">
                                {item.recentSalesRevenue != null ? `$${Number(item.recentSalesRevenue).toFixed(0)}` : '$0'}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
